import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from '../../material/material.module';
import { CommonModule } from '@angular/common';
import { PlanStatusService } from '../../services/plan-status-cache.service';
import { PlanStatusInfo } from '../../../core/generated';

@Component({
    selector: 'app-dialog-plan-status',
    standalone: true,
    imports: [MaterialModule, CommonModule],
    template: `
  <div class="modal-backdrop">
    <div class="modal-container">
      <div class="modal">
        <div class="modal-header">
          <h3 class="modal-title">Consulta de Plano</h3>
        </div>

        <mat-dialog-content class="modal-body">
          <div *ngIf="loading" class="spinner-container" style="min-height: 200px;">
            <mat-progress-spinner diameter="40" mode="indeterminate"></mat-progress-spinner>
            <p style="margin-top: 16px;">Carregando informações para CPF/CNPJ: <strong>{{cpf}}</strong></p>
          </div>

          <div *ngIf="error" class="alert alert-error">
            <mat-icon>error</mat-icon>
            <div>
              <strong>Erro:</strong> {{error}}
            </div>
          </div>

          <div *ngIf="!loading && !error && planStatuses.length === 0" class="alert alert-info">
            <mat-icon>info</mat-icon>
            <div>
              Nenhum registro encontrado para <strong>{{cpf}}</strong>.
            </div>
          </div>

          <div *ngIf="!loading && planStatuses.length > 0">
            <mat-accordion>
              <mat-expansion-panel *ngFor="let p of planStatuses" class="card">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <strong>{{p.planName || ('Plano ' + p.planId)}}</strong>
                  </mat-panel-title>
                  <mat-panel-description>
                    <span class="badge" [ngClass]="{
                      'badge-success': p.isActive,
                      'badge-warning': !p.isActive && p.requiresAction,
                      'badge-error': !p.isActive && !p.requiresAction
                    }">
                      {{p.status}}
                    </span>
                  </mat-panel-description>
                </mat-expansion-panel-header>

                <div class="card-body">
                  <div class="info-row">
                    <span class="info-label">CPF/CNPJ:</span>
                    <span class="info-separator"></span>
                    <span class="info-data">{{p.cpfCnpj}}</span>
                  </div>
                  <div class="info-row">
                    <span class="info-label">Permite Acesso:</span>
                    <span class="info-separator"></span>
                    <span class="info-data">{{p.allowsAccess ? 'Sim' : 'Não'}}</span>
                  </div>
                  <div class="info-row">
                    <span class="info-label">Requer Ação:</span>
                    <span class="info-separator"></span>
                    <span class="info-data">{{p.requiresAction ? 'Sim' : 'Não'}}</span>
                  </div>
                  <div class="info-row">
                    <span class="info-label">Ativo:</span>
                    <span class="info-separator"></span>
                    <span class="info-data">{{p.isActive ? 'Sim' : 'Não'}}</span>
                  </div>
                  <div class="info-row" *ngIf="p.daysRemaining !== null && p.daysRemaining !== undefined">
                    <span class="info-label">Dias Restantes:</span>
                    <span class="info-separator"></span>
                    <span class="info-data">{{p.daysRemaining}}</span>
                  </div>
                  <div class="info-row" *ngIf="p.message">
                    <span class="info-label">Mensagem:</span>
                    <span class="info-separator"></span>
                    <span class="info-data">{{p.message}}</span>
                  </div>
                  <div class="info-row">
                    <span class="info-label">Valor Total:</span>
                    <span class="info-separator"></span>
                    <span class="info-data">R$ {{p.totalValue ?? 0 | number:'1.2-2'}}</span>
                  </div>
                  <div class="info-row" *ngIf="p.pendingAmount">
                    <span class="info-label">Valor Pendente:</span>
                    <span class="info-separator"></span>
                    <span class="info-data">R$ {{p.pendingAmount | number:'1.2-2'}}</span>
                  </div>
                  <div class="info-row" *ngIf="p.lastPaymentDate">
                    <span class="info-label">Último Pagamento:</span>
                    <span class="info-separator"></span>
                    <span class="info-data">{{p.lastPaymentDate | date:'dd/MM/yyyy'}}</span>
                  </div>
                  <div class="info-row" *ngIf="p.nextPaymentDate">
                    <span class="info-label">Próximo Pagamento:</span>
                    <span class="info-separator"></span>
                    <span class="info-data">{{p.nextPaymentDate | date:'dd/MM/yyyy'}}</span>
                  </div>
                  <div class="info-row">
                    <span class="info-label">Criado em:</span>
                    <span class="info-separator"></span>
                    <span class="info-data">{{p.createdAt | date:'dd/MM/yyyy HH:mm'}}</span>
                  </div>
                  <div class="info-row">
                    <span class="info-label">Atualizado em:</span>
                    <span class="info-separator"></span>
                    <span class="info-data">{{p.updatedAt | date:'dd/MM/yyyy HH:mm'}}</span>
                  </div>
                  <div class="info-row" *ngIf="p.expiresAt">
                    <span class="info-label">Vence em:</span>
                    <span class="info-separator"></span>
                    <span class="info-data">{{p.expiresAt | date:'dd/MM/yyyy'}}</span>
                  </div>
                  <div class="info-row" *ngIf="p.daysOverdue">
                    <span class="info-label">Dias em Atraso:</span>
                    <span class="info-separator"></span>
                    <span class="info-data" style="color: var(--color-error);">{{p.daysOverdue}}</span>
                  </div>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </mat-dialog-content>

        <mat-dialog-actions class="modal-footer">
          <button mat-button class="btn btn-ghost" (click)="refresh()">
            <mat-icon>refresh</mat-icon> Atualizar
          </button>
          <button mat-button class="btn btn-primary" (click)="close()">Fechar</button>
        </mat-dialog-actions>
      </div>
    </div>
  </div>
  `,
    styles: [`
    .info-row { margin-bottom: var(--spacing-sm); }
    mat-expansion-panel { margin-bottom: var(--spacing-md); }
  `]
})
export class DialogPlanStatusComponent implements OnInit {
  cpf: string;
  planStatuses: PlanStatusInfo[] = [];
  loading = false;
  error: string | null = null;

  constructor(
    public dialogRef: MatDialogRef<DialogPlanStatusComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { cpf: string },
    private planStatusService: PlanStatusService
  ) {
    this.cpf = data?.cpf || '';
  }

  ngOnInit(): void {
    this.load();
  }

  async load(): Promise<void> {
    if (!this.cpf) {
      this.planStatuses = [];
      return;
    }
    this.loading = true;
    this.error = null;
    try {
      this.planStatuses = await this.planStatusService.fetchForCpfCnpj(this.cpf);
    } catch (err: any) {
      console.error('DialogPlanStatus: error loading plan statuses', err);
      this.error = err?.message || 'Erro ao carregar informações';
      this.planStatuses = [];
    } finally {
      this.loading = false;
    }
  }

  async refresh(): Promise<void> {
    await this.load();
  }

  close(): void {
    this.dialogRef.close();
  }
}
